// src/types/constants.ts
var Constants = {
  ACCESS_TOKEN: "access_token",
  USERNAME: "username"
};

// src/types/env.ts
var ServerEnv = {
  JWT_SECRET: "JWT_SECRET",
  PORT: "PORT",
  ENCRYPTION_KEY: "ENCRYPTION_KEY",
  DATABASE_URL: "DATABASE_URL",
  FRONTEND_URL: "FRONTEND_URL",
  BACKEND_URL: "BACKEND_URL"
};

// src/types/type-guards.ts
function isRecord(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

// src/utils/assert.ts
var assert = (value, message = "Value is not defined") => {
  if (value === null || value === void 0) {
    throw new Error(message);
  }
};

// src/utils/jwt.ts
var parseJWT = (token) => {
  const payloadBase64 = token.split(".")[1];
  if (!payloadBase64) {
    throw new Error("Invalid token");
  }
  const payloadJson = atob(payloadBase64);
  return JSON.parse(payloadJson);
};

// src/utils/lodash.ts
import groupBy from "lodash.groupby";
import keyBy from "lodash.keyby";
import uniq from "lodash.uniq";

// src/utils/partition.ts
var partition = (array, predicate) => array.reduce(
  ([pass, fail], item) => predicate(item) ? [[...pass, item], fail] : [pass, [...fail, item]],
  [[], []]
);
export {
  Constants,
  ServerEnv,
  assert,
  groupBy,
  isRecord,
  keyBy,
  parseJWT,
  partition,
  uniq
};
